import axios from 'axios';
import { apiRoute } from '../constants/api-constants';

/**
 * THE ORGANISATION'S NAME (Plan 3 F2). Owner only on the server
 * (billing:manage); the caller's own organisation by construction — there is
 * no id to pass.
 *
 * `name` is '' while the organisation still carries signup's placeholder;
 * `suggested_name` is then the first building's name, for prefilling.
 */
export interface OrganizationName {
  name: string;
  name_confirmed: boolean;
  suggested_name: string;
}

export const getOrganization = async (): Promise<OrganizationName> => {
  const { data } = await axios.get(`${apiRoute}/organization`);

  return data as OrganizationName;
};

export const renameOrganization = async (name: string): Promise<OrganizationName> => {
  const { data } = await axios.patch(`${apiRoute}/organization`, { name });

  return data as OrganizationName;
};

/** The server's sentence for a refused name, or a generic one. */
export const organizationNameError = (error: unknown): string => {
  const data = (
    error as {
      response?: { status?: number; data?: { message?: string } };
    }
  )?.response;
  if (data?.status === 400 && data.data?.message) return data.data.message;

  return 'Could not save the name. Please try again.';
};
